module.exports = __webpack_public_path__ + "static/img/blue-logo.b767312.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blue-logo.png
// module id = 26
// module chunks = 1